import { Link } from 'react-router-dom';
import { isOfficialIdentity } from '../utils/identityUtils';
import OfficialBadge from './OfficialBadge';

type Props = {
  identityName: string;
  size?: 'sm' | 'md' | 'lg';
};

export default function IdentityButton({ identityName, size = 'md' }: Props) {
  const hasPrefix = identityName.startsWith('@@');
  const displayName = hasPrefix ? identityName.slice(2) : identityName;
  const isShinkaiIdentity = displayName.endsWith('.sep-shinkai');
  const showPrefix = isShinkaiIdentity;
  const isOfficial = isOfficialIdentity(displayName);
  const href = isShinkaiIdentity ? `/identity/${displayName}` : undefined;

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  const content = (
    <>
      <span className="font-medium text-text-default group-hover:text-brand transition-colors truncate max-w-[150px] md:max-w-[220px]">
        {showPrefix && (
          <span className="text-text-tertiary/70 group-hover:text-brand/60 mr-0.5 transition-colors">
            @@
          </span>
        )}
        {displayName}
      </span>

      {isOfficial && <OfficialBadge hideLabel />}
    </>
  );

  const className = `
        inline-flex items-center gap-2 rounded-full
        bg-bg-tertiary/30 border border-divider
        hover:bg-brand/10 hover:border-brand/30 hover:shadow-[0_0_10px_rgba(var(--brand-rgb),0.1)]
        transition-all duration-300 group backdrop-blur-sm
        ${sizeClasses[size]}
      `;

  if (href) {
    return (
      <Link to={href} className={className}>
        {content}
      </Link>
    );
  }

  return <span className={className}>{content}</span>;
}
